'use strict';

exports.__esModule = true;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SVGIcon = require('ad-react-components/lib/SVGIcon');

var _SVGIcon2 = _interopRequireDefault(_SVGIcon);

var _genericResult = require('../generic-result');

var _genericResult2 = _interopRequireDefault(_genericResult);

var _facet = require('./facet.scss');

var _facet2 = _interopRequireDefault(_facet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
    result: _propTypes2.default.shape({
        type: _propTypes2.default.string,
        label: _propTypes2.default.string,
        count: _propTypes2.default.integer,
        query: _propTypes2.default.string
    }).isRequired,
    searchQuery: _propTypes2.default.string.isRequired,
    onClick: _propTypes2.default.func.isRequired,
    index: _propTypes2.default.number.isRequired,
    highlightIndex: _propTypes2.default.number,
    savedQuery: _propTypes2.default.string,
    setResultSelection: _propTypes2.default.func.isRequired,
    getContainerRect: _propTypes2.default.func.isRequired,
    scrollIntoView: _propTypes2.default.func.isRequired
};

var defaultProps = {
    highlightIndex: -1
};

var FacetResult = function (_React$Component) {
    _inherits(FacetResult, _React$Component);

    function FacetResult() {
        _classCallCheck(this, FacetResult);

        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }

    FacetResult.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (prevProps.highlightIndex !== this.props.highlightIndex && this.props.index === this.props.highlightIndex) {
            this.props.setResultSelection(this.getResultQuery());
        }
    };

    FacetResult.prototype.getResultQuery = function getResultQuery() {
        var _props = this.props,
            savedQuery = _props.savedQuery,
            searchQuery = _props.searchQuery,
            result = _props.result;

        return (savedQuery || searchQuery) + ' in ' + result.type;
    };

    FacetResult.prototype.render = function render() {
        var _this2 = this;

        return _react2.default.createElement(
            _genericResult2.default,
            {
                onClick: function onClick() {
                    _this2.props.onClick(_this2.getResultQuery());
                },
                index: this.props.index,
                highlightIndex: this.props.highlightIndex,
                getContainerRect: this.props.getContainerRect,
                scrollIntoView: this.props.scrollIntoView
            },
            _react2.default.createElement(
                'div',
                { className: _facet2.default.icon },
                _react2.default.createElement(_SVGIcon2.default, { type: 'search', width: _facet2.default.iconSize, fill: _facet2.default.iconColor })
            ),
            _react2.default.createElement(
                'div',
                { className: _facet2.default.content },
                _react2.default.createElement(
                    'span',
                    { className: _facet2.default.searchTermLabel },
                    this.props.savedQuery || this.props.searchQuery
                ),
                '\xA0in\xA0',
                _react2.default.createElement(
                    'span',
                    { className: _facet2.default.facetLabel },
                    this.props.result.type
                ),
                '\xA0(',
                this.props.result.count,
                ')'
            )
        );
    };

    return FacetResult;
}(_react2.default.Component);

exports.default = FacetResult;


FacetResult.propTypes = propTypes;
FacetResult.defaultProps = defaultProps;